import React from 'react';
import { ThemeProvider } from 'styled-components';

import lightblue from '@material-ui/core/colors/lightBlue';
import deepOrange from '@material-ui/core/colors/deepOrange';
import { alpha, createTheme, StylesProvider } from '@material-ui/core/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
      light: lightblue[50]
    },
    secondary: {
      light: '#f1f3f3',
      main: '#fff'
    },
    error: {
      main: deepOrange['A400']
    }
  },
  typography: {
    h2: { fontSize: 22, fontWeight: 'bold' },
    overline: {
      letterSpacing: 1,
      fontWeight: 500
    }
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 960,
      xl: 1024
    }
  },
  overrides: {
    MuiListItemIcon: {
      root: {
        minWidth: 36
      }
    },
    MuiInputBase: {
      input: {
        fontSize: 14
      }
    },
    MuiInputLabel: {
      outlined: {
        transform: 'translate(14px, 18px) scale(1)'
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: '16px 14px'
      }
    },
    MuiSelect: {
      root: {
        display: 'flex',
        alignItems: 'center'
      }
    },
    MuiFormControlLabel: {
      label: {
        fontSize: 13
      }
    },
    MuiTableContainer: {
      root: {
        overflow: 'auto'
      }
    },
    MuiTable: {
      root: {
        whiteSpace: 'nowrap'
      }
    },
    MuiTableRow: {
      hover: {
        cursor: 'pointer'
      },
      root: {
        '&$selected, &$selected:hover': { backgroundColor: lightblue[50] },
        '&.deleted': {
          backgroundColor: alpha(deepOrange['A400'], 0.1)
        }
      }
    },
    MuiDialog: {
      paper: {
        width: '80%'
      }
    },
    MuiDialogActions: {
      root: {
        padding: '8px 24px'
      }
    }
  }
});

const AppThemeProvider: React.FC = props => {
  const { children } = props;
  // NOTE: MuiThemeProvider already exists in <SiteThemeProvider> and
  // may cause styling issues when duplicated:
  // Mui classNames get a number suffix (e.g. MuiButtonBase-root-123)
  // which cannot be matched via `.MuiButtonBase-root { ... }` in styled components.
  // Pass the `theme` instead to <SiteProvider>
  return (
    //Make sure the Material stylesheet is placed above your own
    //styles so you can overwrite them
    <StylesProvider injectFirst>
      {/* Use also the ThemeProvider for Styled-Components so you can access
      the theme in your own css */}
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StylesProvider>
  );
};

export default AppThemeProvider;
